import React, { Component } from 'react';
import { ImageLoader } from './ImageLoader';
import './Game_Equipment.css';
import GameAPI from './GameAPI';
import { GameItemTooltip } from './Game_ItemTooltip';
import { MEDIA_VARIANTS } from '../../media';
import ItemSlot from '../../ui/ItemSlot';
import { isTouchPointer } from './touchItemDrag';

export class GameEquipment extends Component {
    constructor(props) {
        super(props);
        this.state = {
            itemsLoaded: false,
            equipment: {
                Helmet: null,
                BodyArmor: null,
                LegArmor: null,
                Weapon: null,
                Boots: null,
                Gloves: null,
                Belt: null,
            },
            tooltip: null,
        };

        this.tooltipAnchor = null;
        this.tooltipPinned = false;
        this.suppressClickUntil = 0;
        this.unequippingItemId = null;
    }

    unEquipItem = async (itemId) => {
        if (
            this.props.inventoryActionsDisabled
            || !itemId
            || this.unequippingItemId
        ) {
            return;
        }

        // send with a default target slot; server will find a free slot if occupied
        this.unequippingItemId = itemId;
        this.hideTooltip(true);
        try {
            await GameAPI.unEquipItem(itemId, 0, 0);
        } catch {
            // apiPost already reports the server error through the shared toast host.
        } finally {
            this.unequippingItemId = null;
        }
    };

    async componentDidMount() {
        this.setState({ itemTypes: await GameAPI.fetchItemTypes() });
    }

    mapEquipment = async () => {
        const { itemTypes } = this.state;
        const { userEquipment } = this.props;
        //while itemTypes is not loaded, wait
        if (!itemTypes) {
            return;
        }
        const equipment = {
            Helmet: userEquipment?.find(x => x.itemTypeId === itemTypes.find(item => item.name === 'Helmet')?.id),
            BodyArmor: userEquipment?.find(x => x.itemTypeId === itemTypes.find(item => item.name === 'BodyArmor')?.id),
            Weapon: userEquipment?.find(x => x.itemTypeId === itemTypes.find(item => item.name === 'Weapon')?.id),
            Boots: userEquipment?.find(x => x.itemTypeId === itemTypes.find(item => item.name === 'Boots')?.id),
            Gloves: userEquipment?.find(x => x.itemTypeId === itemTypes.find(item => item.name === 'Gloves')?.id),
            LegArmor: userEquipment?.find(x => x.itemTypeId === itemTypes.find(item => item.name === 'LegArmor')?.id),
            Belt: userEquipment?.find(x => x.itemTypeId === itemTypes.find(item => item.name === 'Belt')?.id),


        };
        this.setState({ equipment });
    };

    componentDidUpdate(prevProps, prevState) {
        if (
            this.props.userEquipment !== prevProps.userEquipment
            || this.state.itemTypes !== prevState.itemTypes
        ) {
            this.loadItems();
            this.mapEquipment();
        }
    }


    async loadItems() {
        const userEquipment = this.props.userEquipment;

        if (userEquipment) {
            const itemInstanceIds = userEquipment
                .map((item) => item.itemInstanceId)
                .filter(Boolean);

            await GameAPI.fetchItemInstances(itemInstanceIds);
            const loadedItems = itemInstanceIds.map((itemInstanceId) => GameAPI.fetchItemInstanceCached(itemInstanceId));
            await GameAPI.fetchRarities(loadedItems.map((item) => item?.rarityId));
            this.setState({ itemsLoaded: true });
        }
    }

    getRarityProps = (equipmentItem) => {
        const item = GameAPI.fetchItemInstanceCached(equipmentItem?.itemInstanceId);
        const rarity = GameAPI.fetchRarityCached(item?.rarityId);
        return {
            item,
            itemType: this.state.itemTypes?.find(itemType => (
                itemType.id === (equipmentItem?.itemTypeId || item?.typeId)
            )),
            rarity: rarity?.name?.toLowerCase(),
            rarityColor: rarity?.colorHex,
        };
    };

    onDragStart = (equipmentItem) => {
        if (this.props.inventoryActionsDisabled || !equipmentItem) {
            return;
        }
        this.suppressClickUntil = Date.now() + 1000;
        this.hideTooltip(true);
        this.props.onDragStart({
            item: {
                itemId: equipmentItem.itemId,
                itemInstanceId: equipmentItem.itemInstanceId,
                quantity: 1,
                itemTypeId: equipmentItem.itemTypeId,
            },
            rowIndex: -1,
            colIndex: -1,
            fromComponent: 'equipment',
        });
    };

    onDrop = () => {
        if (this.props.inventoryActionsDisabled) {
            this.props.onDrop?.();
            return;
        }
        if (!this.props.draggedItem?.item) return;
        // const { table } = this.state;
        const { item, rowIndex: fromRow, colIndex: fromCol, fromComponent } = this.props.draggedItem;
        if (fromComponent !== 'inventory') return;
        GameAPI.equipItem(item.itemInstanceId, item.itemId, fromRow, fromCol);

        this.props.onDrop();


    };

    onDragOver = (event) => {
        if (!this.props.inventoryActionsDisabled) {
            event.preventDefault();
        }
    };

    showTooltipForAnchor = (anchor, equipmentItem, interactive = false) => {
        if (!equipmentItem?.itemInstanceId || !anchor || (this.tooltipPinned && !interactive)) {
            return;
        }

        this.tooltipPinned = interactive;
        this.tooltipAnchor = anchor;
        const anchorRect = this.tooltipAnchor?.getBoundingClientRect();
        this.setState({
            tooltip: {
                itemId: equipmentItem.itemId,
                itemInstanceId: equipmentItem.itemInstanceId,
                anchorRect,
                interactive,
                equipmentItem,
            },
        });
    };

    showTooltip = (event, equipmentItem) => {
        this.showTooltipForAnchor(event.currentTarget, equipmentItem);
    };

    hideTooltip = (force = false) => {
        if (this.tooltipPinned && !force) {
            return;
        }

        this.tooltipPinned = false;
        this.tooltipAnchor = null;
        if (this.state.tooltip) {
            this.setState({ tooltip: null });
        }
    };

    getTooltipAnchorRect = () => {
        if (this.tooltipAnchor) {
            return this.tooltipAnchor.getBoundingClientRect();
        }
        return this.state.tooltip?.anchorRect ?? null;
    };

    getTooltipAnchorElement = () => this.tooltipAnchor;

    handleItemClick = (event, equipmentItem) => {
        if (Date.now() < this.suppressClickUntil) {
            this.suppressClickUntil = 0;
            event.preventDefault();
            return;
        }

        this.unEquipItem(equipmentItem?.itemId);
    };

    handleItemPointerUp = (event, equipmentItem) => {
        if (isTouchPointer(event)) {
            this.suppressClickUntil = Date.now() + 1000;
            if (this.props.draggedItem?.fromComponent === 'inventory') {
                this.onDrop();
            } else if (
                this.props.draggedItem?.fromComponent === 'equipment'
                && this.props.draggedItem.item?.itemInstanceId === equipmentItem?.itemInstanceId
            ) {
                this.props.onDrop?.();
            } else if (!this.props.draggedItem?.item) {
                this.showTooltipForAnchor(event.currentTarget, equipmentItem, true);
            }
        }
    };

    getItemActions = (equipmentItem) => {
        const disabled = Boolean(this.props.inventoryActionsDisabled);
        const disabledReason = this.props.inventoryActionsDisabledReason
            || 'Unavailable during your current action';
        return [{
            id: 'unequip',
            label: 'Unequip',
            disabled,
            disabledReason: disabled ? disabledReason : '',
            onSelect: () => this.unEquipItem(equipmentItem?.itemId),
        }, {
            id: 'move',
            label: 'Move to Pack',
            disabled,
            disabledReason: disabled ? disabledReason : '',
            onSelect: () => this.onDragStart(equipmentItem),
        }];
    };

    handleItemKeyDown = (event, equipmentItem) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            this.unEquipItem(equipmentItem?.itemId);
            return;
        }
        if (event.key === ' ') {
            event.preventDefault();
            if (this.props.draggedItem?.item) this.onDrop();
            else this.onDragStart(equipmentItem);
        }
    };

    getItemInteractionProps = (equipmentItem) => {
        if (!equipmentItem?.itemInstanceId) {
            return { tabIndex: -1 };
        }

        const loadedItem = GameAPI.fetchItemInstanceCached(equipmentItem.itemInstanceId);
        return {
            'aria-disabled': this.props.inventoryActionsDisabled || undefined,
            'aria-label': loadedItem?.name || 'Equipped item',
            draggable: !this.props.inventoryActionsDisabled,
            onBlur: () => this.hideTooltip(),
            onClick: (event) => this.handleItemClick(event, equipmentItem),
            onContextMenu: (event) => {
                event.preventDefault();
                this.showTooltipForAnchor(event.currentTarget, equipmentItem, true);
            },
            onDragStart: () => this.onDragStart(equipmentItem),
            onFocus: (event) => this.showTooltip(event, equipmentItem),
            onKeyDown: (event) => this.handleItemKeyDown(event, equipmentItem),
            onMouseEnter: (event) => this.showTooltip(event, equipmentItem),
            onMouseLeave: () => this.hideTooltip(),
            onPointerMove: (event) => {
                if (!isTouchPointer(event)) {
                    this.showTooltip(event, equipmentItem);
                }
            },
            onPointerLeave: () => this.hideTooltip(),
            onPointerUp: (event) => this.handleItemPointerUp(event, equipmentItem),
            role: 'button',
            tabIndex: 0,
        };
    };

    getSlotInteractionProps = () => ({
        'data-compatible': (
            !this.props.inventoryActionsDisabled
            && this.props.draggedItem?.fromComponent === 'inventory'
        ) || undefined,
        onClick: () => {
            if (this.props.draggedItem?.fromComponent === 'inventory') this.onDrop();
        },
        onDragOver: this.onDragOver,
        onDrop: this.onDrop,
        onKeyDown: (event) => {
            if (
                this.props.draggedItem?.fromComponent === 'inventory'
                && (event.key === 'Enter' || event.key === ' ')
            ) {
                event.preventDefault();
                this.onDrop();
            }
        },
        tabIndex: this.props.draggedItem?.fromComponent === 'inventory' ? 0 : undefined,
    });





    render() {
        const { equipment } = this.state;

        return (
            <div className="game-Equipment">
                <div className='equipmentRow'>
                    <div className="equipment-slot-field">
                        <ItemSlot aria-label="Head equipment slot" className="equipment-slot" role="group" {...this.getRarityProps(equipment.Helmet)} {...this.getSlotInteractionProps()}>
                            <div
                                className="item"
                                {...this.getItemInteractionProps(equipment.Helmet)}
                            >
                                <ImageLoader
                                    className="equipmentSlotImage"
                                    imageId={GameAPI.fetchItemInstanceCached(equipment.Helmet?.itemInstanceId)?.imageId}
                                    animatedMediaId={GameAPI.fetchItemInstanceCached(equipment.Helmet?.itemInstanceId)?.animatedMediaId || GameAPI.fetchItemInstanceCached(equipment.Helmet?.itemInstanceId)?.animatedImageId}
                                    itemId={equipment.Helmet?.itemId}
                                    staticPreview
                                    variant={MEDIA_VARIANTS.CARD}
                                />
                            </div>
                        </ItemSlot>
                        <span className="equipment-slot-label">Head</span>
                    </div>
                </div>
                <div className='equipmentRow'>
                    <div className="equipment-slot-field">
                        <ItemSlot aria-label="Weapon equipment slot" className="equipment-slot" role="group" {...this.getRarityProps(equipment.Weapon)} {...this.getSlotInteractionProps()}>
                            <div
                                className="item"
                                {...this.getItemInteractionProps(equipment.Weapon)}
                            >
                                <ImageLoader
                                    className="equipmentSlotImage"
                                    imageId={GameAPI.fetchItemInstanceCached(equipment.Weapon?.itemInstanceId)?.imageId}
                                    animatedMediaId={GameAPI.fetchItemInstanceCached(equipment.Weapon?.itemInstanceId)?.animatedMediaId || GameAPI.fetchItemInstanceCached(equipment.Weapon?.itemInstanceId)?.animatedImageId}
                                    itemId={equipment.Weapon?.itemId}
                                    staticPreview
                                    variant={MEDIA_VARIANTS.CARD}
                                />
                            </div>
                        </ItemSlot>
                        <span className="equipment-slot-label">Weapon</span>
                    </div>
                    <div className="equipment-slot-field">
                        <ItemSlot aria-label="Body equipment slot" className="equipment-slot" role="group" {...this.getRarityProps(equipment.BodyArmor)} {...this.getSlotInteractionProps()}>
                            <div
                                className="item"
                                {...this.getItemInteractionProps(equipment.BodyArmor)}
                            >
                                <ImageLoader
                                    className="equipmentSlotImage"
                                    imageId={GameAPI.fetchItemInstanceCached(equipment.BodyArmor?.itemInstanceId)?.imageId}
                                    animatedMediaId={GameAPI.fetchItemInstanceCached(equipment.BodyArmor?.itemInstanceId)?.animatedMediaId || GameAPI.fetchItemInstanceCached(equipment.BodyArmor?.itemInstanceId)?.animatedImageId}
                                    itemId={equipment.BodyArmor?.itemId}
                                    staticPreview
                                    variant={MEDIA_VARIANTS.CARD}
                                />
                            </div>
                        </ItemSlot>
                        <span className="equipment-slot-label">Body</span>
                    </div>
                </div>
                <div className='equipmentRow'>
                    <div className="equipment-slot-field">
                        <ItemSlot aria-label="Hands equipment slot" className="equipment-slot" role="group" {...this.getRarityProps(equipment.Gloves)} {...this.getSlotInteractionProps()}>
                            <div
                                className="item"
                                {...this.getItemInteractionProps(equipment.Gloves)}
                            >
                                <ImageLoader
                                    className="equipmentSlotImage"
                                    imageId={GameAPI.fetchItemInstanceCached(equipment.Gloves?.itemInstanceId)?.imageId}
                                    animatedMediaId={GameAPI.fetchItemInstanceCached(equipment.Gloves?.itemInstanceId)?.animatedMediaId || GameAPI.fetchItemInstanceCached(equipment.Gloves?.itemInstanceId)?.animatedImageId}
                                    itemId={equipment.Gloves?.itemId}
                                    staticPreview
                                    variant={MEDIA_VARIANTS.CARD}
                                />
                            </div>
                        </ItemSlot>
                        <span className="equipment-slot-label">Hands</span>
                    </div>
                    <div className="equipment-slot-field">
                        <ItemSlot aria-label="Legs equipment slot" className="equipment-slot" role="group" {...this.getRarityProps(equipment.LegArmor)} {...this.getSlotInteractionProps()}>
                            <div
                                className="item"
                                {...this.getItemInteractionProps(equipment.LegArmor)}
                            >
                                <ImageLoader
                                    className="equipmentSlotImage"
                                    imageId={GameAPI.fetchItemInstanceCached(equipment.LegArmor?.itemInstanceId)?.imageId}
                                    animatedMediaId={GameAPI.fetchItemInstanceCached(equipment.LegArmor?.itemInstanceId)?.animatedMediaId || GameAPI.fetchItemInstanceCached(equipment.LegArmor?.itemInstanceId)?.animatedImageId}
                                    itemId={equipment.LegArmor?.itemId}
                                    staticPreview
                                    variant={MEDIA_VARIANTS.CARD}
                                />
                            </div>
                        </ItemSlot>
                        <span className="equipment-slot-label">Legs</span>
                    </div>
                    <div className="equipment-slot-field">
                        <ItemSlot aria-label="Feet equipment slot" className="equipment-slot" role="group" {...this.getRarityProps(equipment.Boots)} {...this.getSlotInteractionProps()}>
                            <div
                                className="item"
                                {...this.getItemInteractionProps(equipment.Boots)}
                            >
                                <ImageLoader
                                    className="equipmentSlotImage"
                                    imageId={GameAPI.fetchItemInstanceCached(equipment.Boots?.itemInstanceId)?.imageId}
                                    animatedMediaId={GameAPI.fetchItemInstanceCached(equipment.Boots?.itemInstanceId)?.animatedMediaId || GameAPI.fetchItemInstanceCached(equipment.Boots?.itemInstanceId)?.animatedImageId}
                                    itemId={equipment.Boots?.itemId}
                                    staticPreview
                                    variant={MEDIA_VARIANTS.CARD}
                                />
                            </div>
                        </ItemSlot>
                        <span className="equipment-slot-label">Feet</span>
                    </div>
                </div>
                <div className='equipmentRow'>
                    <div className="equipment-slot-field">
                        <ItemSlot aria-label="Belt equipment slot" className="equipment-slot" role="group" {...this.getRarityProps(equipment.Belt)} {...this.getSlotInteractionProps()}>
                            <div className="item" {...this.getItemInteractionProps(equipment.Belt)}>
                                <ImageLoader
                                    className="equipmentSlotImage"
                                    imageId={GameAPI.fetchItemInstanceCached(equipment.Belt?.itemInstanceId)?.imageId}
                                    animatedMediaId={GameAPI.fetchItemInstanceCached(equipment.Belt?.itemInstanceId)?.animatedMediaId || GameAPI.fetchItemInstanceCached(equipment.Belt?.itemInstanceId)?.animatedImageId}
                                    itemId={equipment.Belt?.itemId}
                                    staticPreview
                                    variant={MEDIA_VARIANTS.CARD}
                                />
                            </div>
                        </ItemSlot>
                        <span className="equipment-slot-label">Belt</span>
                    </div>
                </div>
                {this.state.tooltip && (
                    <GameItemTooltip
                        itemId={this.state.tooltip.itemId}
                        itemInstanceId={this.state.tooltip.itemInstanceId}
                        anchorRect={this.state.tooltip.anchorRect}
                        getAnchorRect={this.getTooltipAnchorRect}
                        getAnchorElement={this.getTooltipAnchorElement}
                        interactive={this.state.tooltip.interactive}
                        actions={this.getItemActions(this.state.tooltip.equipmentItem)}
                        onRequestClose={() => this.hideTooltip(true)}
                    />
                )}
            </div>
        );
    }
}
